<script lang="ts">
	import { getClassicWebUrl, getUserActions } from "$lib/components/currentUser";

	const CLASSIC_WEB_URL = getClassicWebUrl();

	const {
		expirationNotification: { callToAction, description, descriptionHtml, expirationType, href: originalHref, title, isPost, circleError }
	} = getUserActions();

	const href = originalHref?.startsWith("/") ? `${CLASSIC_WEB_URL}${originalHref}` : originalHref;
</script>

<div class="flex items-center py-4 {expirationType} text-[#222222]" role="banner">
	<svelte:element this={isPost ? "div" : "a"} class="container-1200 flex flex-wrap items-center justify-between lg:flex-nowrap" {href}>
		<div class="items-center pr-2 lg:flex">
			<span class="material-icons mr-1 text-18 text-orange-600" class:text-orange-600={circleError} class:text-white={!circleError}
				>{circleError ? "info" : "warning"}</span>
			<span class="font-bold">{title}</span>
			{description || ""}
			{#if descriptionHtml}
				<span class="ml-1">{@html descriptionHtml || ""}</span>
			{/if}
		</div>

		{#if isPost}
			<form action={href} method="post" class="hidden font-bold lg:inline-block">
				<button type="submit">{callToAction}</button>
			</form>
		{:else}
			<div class="hidden font-bold lg:inline-block">
				{callToAction}
			</div>
		{/if}
	</svelte:element>
</div>

<style>
	.expires-in-4-weeks {
		background-color: #f8f8f8;
	}

	.expires-in-2-weeks {
		background: #fbd85c;
	}

	.expired,
	.expires-in-1-week,
	.archived {
		background-color: #d42c2c;
		color: white;
	}

	.expired button,
	.expires-in-1-week button,
	.archived button {
		background: transparent;
		color: white;
		border: none;
		cursor: pointer;
	}
</style>
